import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  createCategory,
  updateCategory,
  selectCategories,
  fetchCategoriesTree,
} from "./categoriesSlice";
import { checkFieldUpdate } from "../../common/utils";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import IconButton from "@material-ui/core/IconButton";
import InputLabel from "@material-ui/core/InputLabel";
import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
// import FormHelperText from '@material-ui/core/FormHelperText';

import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

import CategoriesSelect from "../../components/CategoriesSelect";

import { makeStyles, withStyles } from "@material-ui/core/styles";

const ColorButton = withStyles((theme) => ({
  root: {
    // margin: theme.spacing(3, 0, 2),
    margin: theme.spacing(0, 0, 0),
    backgroundColor: "#D86D7E",
    color: "#FFF",
    "&:hover": {
      opacity: 0.9,
      backgroundColor: "#D86D7E",
    },
    width: "100%",
    // fontWeight: 'bold',
  },
}))(Button);

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  outer: { display: "flex", flexFlow: "column" },
  addIcon: {
    marginRight: 8,
    color: "#fff",
  },
  title: {
    color: "#fff",
    padding: 16,
    backgroundColor: " #42494E",
    textAlign: "center",
    fontSize: 24,
    fontWeight: "bold",
  },
  textItem: {
    marginBottom: 16,
  },
  formControl: {
    marginBottom: 6,
    minWidth: 120,
    width: "100%",
    // maxWidth: 400,
  },

  imagesContainer: {
    border: "1px solid #DDD",
    padding: 12,
    borderRadius: 4,
    marginTop: 24,
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left",
  },

  getContentAnchorEl: null,
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function Category(props) {
  const { edit, product } = props;
  const classes = useStyles();

  let jwtToken = localStorage.getItem("coreToken");
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [statusID, setStatusID] = useState([]);
  const [statusList, setStatusList] = useState([
    { id: 1, value: "active" },
    { id: 2, value: "inactive" },
    { id: 3, value: "deleted" },
    { id: 4, value: "unavailable" },
  ]);
  const [editCategory, setEditCategory] = useState(false);
  const [menuPosition, setMenuPosition] = useState(null);

  const [productStatus, setProductStatus] = useState("");

  const [checked, setCategoriesChecked] = useState([]);
  const [names, setNames] = useState([]);

  const [images, setImages] = useState([]);
  const { editing, category, categoriesTree } = useSelector(selectCategories);

  const handleToggle = (e, value, name) => {
    e.stopPropagation();
    const currentIndex = checked.indexOf(value);
    const newChecked = [];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    const currentNameIndex = names.indexOf(name);
    const newNames = [];

    if (currentNameIndex === -1) {
      newNames.push(name);
    } else {
      newNames.splice(currentNameIndex, 1);
    }
    setNames(newNames);
    setCategoriesChecked(newChecked);
    // setNames([name]);
    // setCategoriesChecked([value]);
  };

  useEffect(() => {
    if (!categoriesTree.length) {
      dispatch(
        fetchCategoriesTree({
          token: jwtToken,
        })
      );
    }
  }, []);

  useEffect(() => {
    if (editing && category !== {}) {
      setName(category.name);
      setDescription(category.description);
      setStatusID(category.statusID);
      setProductStatus(statusList[category.statusID - 1].value);
      setEditCategory(true);
      setNames([category.parentName]);
      setCategoriesChecked([category.parentID]);
      setOpen(true);
      setImages([]);
    }
  }, [category]);

  const handleClickOpen = () => {
    setName("");
    setDescription("");
    setStatusID([]);
    setProductStatus("");
    setEditCategory(false);
    setNames([]);
    setCategoriesChecked([]);
    setImages([]);
    setOpen(true);
  };

  const handleClose = () => {
    setName("");
    setDescription("");
    setStatusID([]);
    setProductStatus("");
    setEditCategory(false);
    setNames([]);
    setCategoriesChecked([]);
    setImages([]);
    setOpen(false);
  };

  const handleCatsOpen = (event) => {
    if (menuPosition) {
      return;
    }
    event.preventDefault();
    setMenuPosition({
      top: event.clientY,
      left: event.clientX - 300,
    });
  };

  const handleStatusChange = (event) => {
    let selectedStatus = statusList.filter(
      (status) => status.value === event.target.value
    );
    selectedStatus[0] && setStatusID(selectedStatus[0].id);

    setProductStatus(event.target.value);
  };

  const handleCreate = (e) => {
    e.preventDefault();
    let categoryData = {
      statusID: statusID,
      name: name,
      description: description,
    };

    if (names.length) {
      categoryData.parentID = checked[0];
    }

    dispatch(
      createCategory({
        category: categoryData,
        token: jwtToken,
      })
    );
  };

  const handleUpdate = (e) => {
    e.preventDefault();

    const updatedCategory = checkFieldUpdate(
      [
        { name: "statusID", val: statusID },
        { name: "name", val: name },
        { name: "description", val: description },
        { name: "parentID", val: checked.length ? checked[0] : null },
      ],
      category
    );
    dispatch(
      updateCategory({
        category: updatedCategory,
        token: jwtToken,
        id: category.id,
      })
    );
  };

  // const updateAltTexts = (text, imageIndex) => {
  //   const newImages = images.map((image, index) => {
  //     if (imageIndex === index) {
  //       // check if fieldName equals to cityId
  //       return {
  //         ...image,
  //         altText: text,
  //       };
  //     } else {
  //       return image;
  //     }
  //   });
  //   setImages(newImages);
  // };

  // const updateMediaTitles = (title, imageIndex) => {
  //   const newImages = images.map((image, index) => {
  //     if (imageIndex === index) {
  //       // check if fieldName equals to cityId
  //       return {
  //         ...image,
  //         title: title,
  //       };
  //     } else {
  //       return image;
  //     }
  //   });
  //   setImages(newImages);
  // };

  // const filesCB = (filesList) => {
  //   for (let i = 0; i < filesList.length; i++) {
  //     const file = filesList[i];
  //     let objName = URL.createObjectURL(file);
  //     let imageFile = {
  //       id: `${i}-uploaded`,
  //       objName: objName,
  //       name: file.name,
  //       file: file,
  //     };

  //     setImages((images) => {
  //       return [...images, imageFile];
  //     });
  //   }
  // };

  // const removeImage = (e, url) => {
  //   let updatedUrls = images.filter((image) => image.objName !== url);
  //   setImages(updatedUrls);
  // };

  return (
    <div>
      <IconButton
        aria-label="add new"
        style={product ? { marginTop: 16 } : { marginLeft: 0 }}
      >
        <AddCircleIcon
          style={
            product ? { marginRight: 0 } : { marginRight: 0, color: "#fff" }
          }
          onClick={handleClickOpen}
        />
      </IconButton>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        fullWidth={true}
        maxWidth="lg"
        id={"category-dialog"}
      >
        <form
          onSubmit={
            editCategory ? (e) => handleUpdate(e) : (e) => handleCreate(e)
          }
        >
          <DialogTitle
            disableTypography
            className={classes.title}
            id="form-dialog-title"
          >
            {editCategory ? "Edit Category" : "Add Category"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText style={{ paddingTop: 8, textAlign: "center" }}>
              {editCategory
                ? "Update Category Details"
                : "Enter Category Details"}
            </DialogContentText>
            <Grid container direction="column">
              <Grid item sm>
                <TextField
                  className={classes.textItem}
                  defaultValue={name}
                  variant="outlined"
                  autoFocus
                  margin="dense"
                  required
                  id="name"
                  label="Name"
                  type="name"
                  fullWidth
                  onChange={(e) => setName(e.target.value)}
                />
              </Grid>{" "}
              <Grid item sm>
                <TextField
                  className={classes.textItem}
                  variant="outlined"
                  defaultValue={description}
                  multiline
                  rows={4}
                  margin="dense"
                  id="description"
                  label="Description"
                  type="description"
                  fullWidth
                  onChange={(e) => setDescription(e.target.value)}
                />
              </Grid>
              <Grid item sm style={{ paddingTop: 8 }}>
                <FormControl
                  variant="outlined"
                  className={classes.formControl}
                  style={{
                    width: "100%",
                  }}
                >
                  <InputLabel htmlFor="outlined-status-simple" margin="dense">
                    Category Status*
                  </InputLabel>
                  <Select
                    value={productStatus}
                    onChange={(e) => handleStatusChange(e)}
                    margin="dense"
                    label="Category Status*"
                    required
                    inputProps={{
                      name: "status",
                      id: "outlined-status-simple",
                    }}
                  >
                    <MenuItem value="active">Active</MenuItem>
                    <MenuItem value="inactive">Inactive</MenuItem>
                    <MenuItem value="unavailable">Unavailable</MenuItem>
                    <MenuItem value="deleted">Deleted</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item sm style={{ paddingTop: 0 }}>
                <FormControl
                  onClick={handleCatsOpen}
                  variant="outlined"
                  margin="dense"
                  className={classes.formControl}
                >
                  <InputLabel id="multiple-checkbox-label-categories">
                    Select Parent Category
                  </InputLabel>
                  <Select
                    margin="dense"
                    labelId="multiple-checkbox-label-categories"
                    id="multiple-checkbox-categories-single"
                    // className={classes.multiContainer}
                    // multiple
                    disabled
                    value={names}
                    input={<Input className={classes.multiContainer} />}
                    displayEmpty
                    renderValue={(selected) => selected.join(", ")}
                    MenuProps={MenuProps}
                  ></Select>
                </FormControl>
                <CategoriesSelect
                  menuPosition={menuPosition}
                  setMenuPosition={setMenuPosition}
                  // handleOpen={handleCatsOpen}
                  checked={checked}
                  names={names}
                  handleToggle={handleToggle}
                  categoryTreeList={categoriesTree}
                  edit={edit}
                  // prodCategories={editCategory ? product.categories : []}
                  prodCategories={editCategory ? [] : []}
                  list={false}
                  classes={classes}
                />
              </Grid>
              {/* <Grid className={classes.imagesContainer}>
              <Typography className={classes.heading}>
                Category Image
              </Typography>
              <Grid
                container
                spacing={3}
                direction="column"
                justifyContent="space between"
                style={{padding: 12, alignItems: 'center'}}
              >
                <Grid item sm className={classes.dropzoneContainer}>
                  <DropZone filesCB={filesCB} />
                </Grid>
                {images &&
                  images.map((image, index) => (
                    <Grid
                      container
                      direction="column"
                      spacing={3}
                      justifyContent="space between"
                      key={image.id}
                      style={{
                        maxWidth: 800,
                        marginBottom: 8,
                      }}
                    >
                      <Grid
                        item
                        sm={3}
                        style={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          paddingLeft: 0,
                        }}
                      >
                        <img
                          src={
                            edit &&
                            images &&
                            images.filter(
                              (prodImage) => prodImage.id === image.id
                            ).length
                              ? `${process.env.REACT_APP_ASSETS_URL}/` +
                                image.objName
                              : image.objName
                          }
                          width={800}
                          // height={}
                        />
                      </Grid>
                      <Grid item sm style={{padding: 0}}>
                        <Grid
                          key={index}
                          container
                          spacing={0}
                          direction="column"
                          justifyContent="space between"
                        >
                          <Grid item sm style={{paddingLeft: 0}}>
                            <TextField
                              // key={image.title}
                              fullWidth
                              defaultValue={image.title}
                              className={classes.mediaDetails}
                              variant="outlined"
                              margin="normal"
                              required
                              margin="dense"
                              id="media-title"
                              label="Title"
                              name="title"
                              autoComplete="text"
                              onChange={(e) =>
                                updateMediaTitles(e.target.value, index)
                              }
                            />
                          </Grid>
                          <Grid item sm>
                            <TextField
                              // key={image.altText}
                              fullWidth
                              defaultValue={image.altText}
                              className={classes.mediaDetails}
                              variant="outlined"
                              margin="normal"
                              required
                              margin="dense"
                              id="alt-text"
                              label="Alternative Text"
                              name="alt"
                              autoComplete="text"
                              onChange={(e) =>
                                updateAltTexts(e.target.value, index)
                              }
                            />
                          </Grid>
                          <Grid item sm style={{marginTop: 8}}>
                            <Button
                              fullWidth
                              className={classes.mediaDetails}
                              variant="contained"
                              color="primary"
                              component="span"
                              onClick={(e) =>
                                removeImage(e, image.objName, index)
                              }
                            >
                              Remove
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  ))}
              </Grid>
            </Grid> */}
            </Grid>
          </DialogContent>
          <DialogActions
            style={{ paddingLeft: 24, paddingRight: 24, paddingBottom: 16 }}
          >
            <Grid container spacing={2} direction="row">
              <Grid item sm>
                <ColorButton onClick={handleClose} color="primary">
                  Cancel
                </ColorButton>
              </Grid>
              <Grid item sm>
                <ColorButton type="submit" color="secondary">
                  {editCategory ? "Edit Category" : "Create Category"}
                </ColorButton>
              </Grid>
            </Grid>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}
